import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { DevTool } from "@hookform/devtools"
import schema from "./Validation"
import { Grid } from "@mui/material"
import { AcademicLevel, Campus, ConsentementMultiple, MentionsLegales, RequiredFields, Submit } from "components"
import { Email, InputText, PhoneNumber, RadioButton } from "components/fields"
import { consent, defaultValues, salutations } from "services"
import { useEffect } from "react"
import RendezVous from "../components/RendezVous"
import Programmes from "../components/Programmes"
import useLandingPage from "../services/useLandingPage"
import { academicLevelsPostBac, campusSansNice, LAST_FORMS, PHONE_CALL } from "../services/landingPages"

const labelProgramme = (title, detail) => (
  <>
    <strong>{title}</strong><br />
    <span style={{ fontSize: 11 }}>{detail}</span>
  </>
)

const PARIS_ONLY = 'Ce programme est uniquement disponible sur le campus de Paris.'

// LP Post-bac : PGE, BMI et BBA sont uniquement à Paris, le PBM est sur les 7 campus
const Form = () => {
  const methods = useForm({
    defaultValues: {
      ...consent,
      rendezVous: PHONE_CALL,
      lead: {
        ...defaultValues,
        Salutation: '',
        PGE__c: false,
        BMI__c: false,
        BBA__c: false,
        PBM__c: false
      }
    },
    resolver: yupResolver(schema)
  })
  const { control, setValue, watch } = methods
  const { submit } = useLandingPage({
    campaignStatus: 'Contact Requested',
    formId: 'CONTACT',
    lastForm: LAST_FORMS.postBac,
    leadSource: 'LP : Demande de contact',
    urlKey: 'ISG-LP-POST-BAC'
  })

  const [pge, bmi, bba, pbm] = watch(['lead.PGE__c', 'lead.BMI__c', 'lead.BBA__c', 'lead.PBM__c'])
  const parisOnly = pge || bmi || bba

  // Un programme parisien force le campus de Paris ; sans programme, aucun campus
  useEffect(() => {
    if (parisOnly) {
      setValue('lead.Campus__c', 'Paris')
    } else if (!pbm) {
      setValue('lead.Campus__c', '')
    }
  }, [parisOnly, pbm, setValue])

  const onSubmit = data => submit({ ...data, campusLabel: "l'un des campus ISG" })

  return (
    <FormProvider {...methods}>
      <DevTool control={control} />
      <Grid container spacing={2}>
        <RendezVous campusLabel="l'un des campus ISG" />
        <Grid item xs={12}>
          <RadioButton control={control} label="Civilité" name="lead.Salutation" options={salutations} required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Prénom" name="lead.FirstName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Nom" name="lead.LastName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Email control={control} label="Adresse e-mail" name="lead.Email" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <PhoneNumber control={control} name="lead.MobilePhone" label="Téléphone" />
        </Grid>
        <AcademicLevel options={academicLevelsPostBac} section={false} specialites={false} />
        <Programmes required={false} programmes={[
          { name: 'lead.PGE__c', label: labelProgramme('Programme Grande École en 5 ans.', PARIS_ONLY) },
          { name: 'lead.BMI__c', label: labelProgramme('Bachelor en management international.', PARIS_ONLY) },
          { name: 'lead.BBA__c', label: labelProgramme('International program BBA.', PARIS_ONLY) },
          { name: 'lead.PBM__c', label: labelProgramme('Programme Business & Management.', "Ce programme est disponible sur les 7 campus de l'ISG en France.") }
        ]} />
        {pbm && (
          <Campus label="Campus de PBM" options={parisOnly ? campusSansNice.filter(el => el.value === 'Paris') : campusSansNice} />
        )}
        <ConsentementMultiple callOptIn />
        <RequiredFields />
        <Submit label="Envoyer" onSubmit={onSubmit} />
        <MentionsLegales form="Contact" school="ISG France" />
      </Grid>
    </FormProvider>
  )
}

export default Form
